import React, { useCallback } from 'react'
import clsx from 'clsx'
import Typography from '@mui/material/Typography'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import Button from 'components/Button'
import { actions, selectors, STEP } from '../../../duck'
import { RootActionType, RootState } from 'duck'
import { ReduxProps } from 'utils/Types'
import { dialogActions } from 'duck/AppDuck/DialogDuck'
import { values } from 'appConstants'
import { useBreakpoint } from 'utils/Hooks'
import styles from '../../NFTSellForm.module.scss'

const mapStateToProps = (state: RootState) => ({
  gridCount: selectors.gridCount(state),
  notEnoughErrorText: selectors.notEnoughErrorText(state)
})

const mapDispatchToProps = (dispatch: Dispatch<RootActionType>) =>
  bindActionCreators(
    {
      closeDialog: dialogActions.closeDialog,
      setStep: actions.setStep
    },
    dispatch
  )

type InfoCurateCollectionProps = ReduxProps<typeof mapDispatchToProps> &
  ReduxProps<typeof mapStateToProps>

const InfoCurateCollection: React.FC<InfoCurateCollectionProps> = props => {
  const { closeDialog, setStep, notEnoughErrorText, gridCount } = props
  const loading = gridCount === undefined
  const isImageLess = !loading && gridCount < values.MINIMUM_SELL_NFT_IMAGE
  const { isSmallscreenAbove } = useBreakpoint()

  const handleClose = useCallback(() => {
    closeDialog()
  }, [closeDialog])

  return (
    <div className={clsx('mx-auto pb-25', !isSmallscreenAbove && 'pt-3', styles.FormWrapper)}>
      <Typography variant="h5" className="mb-9" component="div">
        Step 1: Curate Your Collection
      </Typography>

      <div className="mb-6">
        <Typography variant="body1" className="mb-1">
          Creative Morph, Style Transfer and FaceMix.
        </Typography>

        <Typography variant="subtitle2" className="mb-4 text-white-med-on-dark">
          Before you continue, select the artworks from your model that you would like to make
          available for sale.
        </Typography>

        <Typography variant="subtitle2" className="text-white-med-on-dark">
          Save the results you would like to sell. All artworks in the “SAVED” folder for this
          project will be submitted.
        </Typography>
      </div>

      <div className="mb-8">
        <Typography variant="body1" className="mb-1">
          Stylize Filter, Sketch-to-Art
        </Typography>

        <Typography variant="subtitle2" className="text-white-med-on-dark">
          Delete the results you do not want to sell. All of the results in this project can be
          submitted.
        </Typography>
      </div>

      {isImageLess ? (
        <Typography
          variant="caption"
          color="error"
          className="mt-auto py-4 text-center normal-case"
          component="div"
        >
          {notEnoughErrorText}
        </Typography>
      ) : null}

      <div className="mt-2">
        <Button
          disabled={loading || isImageLess}
          className="mb-4"
          color="secondary"
          variant="contained"
          onClick={() => {
            setStep(STEP.SELECT_COVER)
          }}
          fullWidth
        >
          CONTINUE
        </Button>

        <Button variant="outlined" onClick={handleClose} fullWidth>
          GO BACK TO PROJECT
        </Button>
      </div>
    </div>
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(InfoCurateCollection)
